"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.intentStyle = void 0;

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _styledComponents = require("styled-components");

var _color = _interopRequireDefault(require("@decisiv/design-tokens/lib/color"));

var _CheckCircle = _interopRequireDefault(require("@decisiv/iconix/lib/components/CheckCircle"));

var _ExclamationCircle = _interopRequireDefault(require("@decisiv/iconix/lib/components/ExclamationCircle"));

var _ExclamationTriangle = _interopRequireDefault(require("@decisiv/iconix/lib/components/ExclamationTriangle"));

var _InfoCircle = _interopRequireDefault(require("@decisiv/iconix/lib/components/InfoCircle"));

var _polished = require("polished");

var _ConfigProvider = require("../../providers/ConfigProvider");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var intents = {
  information: {
    color: _color.default.status.information.light,
    borderColor: _color.default.status.information.medium,
    icon: _InfoCircle.default
  },
  success: {
    color: _color.default.status.success.light,
    borderColor: _color.default.status.success.medium,
    icon: _CheckCircle.default
  },
  warning: {
    color: _color.default.status.warning.light,
    borderColor: _color.default.status.warning.medium,
    icon: _ExclamationCircle.default
  },
  danger: {
    color: _color.default.status.danger.light,
    borderColor: _color.default.status.danger.medium,
    icon: _ExclamationTriangle.default
  }
};

var intentStyle = _styledTheming.default.variants(_ConfigProvider.themeKeys.mode, 'intent', {
  information: {
    light: (0, _styledComponents.css)(["background-color:", ";border-left-color:", ";"], (0, _polished.toColorString)(intents.information.color), (0, _polished.toColorString)(intents.information.borderColor)),
    dark: (0, _styledComponents.css)(["background-color:", ";border-left-color:", ";"], (0, _polished.toColorString)(intents.information.color), (0, _polished.toColorString)(intents.information.borderColor))
  },
  success: {
    light: (0, _styledComponents.css)(["background-color:", ";border-left-color:", ";"], (0, _polished.toColorString)(intents.success.color), (0, _polished.toColorString)(intents.success.borderColor)),
    dark: (0, _styledComponents.css)(["background-color:", ";border-left-color:", ";"], (0, _polished.toColorString)(intents.success.color), (0, _polished.toColorString)(intents.success.borderColor))
  },
  warning: {
    light: (0, _styledComponents.css)(["background-color:", ";border-left-color:", ";"], (0, _polished.toColorString)(intents.warning.color), (0, _polished.toColorString)(intents.warning.borderColor)),
    dark: (0, _styledComponents.css)(["background-color:", ";border-left-color:", ";"], (0, _polished.toColorString)(intents.warning.color), (0, _polished.toColorString)(intents.warning.borderColor))
  },
  danger: {
    light: (0, _styledComponents.css)(["background-color:", ";border-left-color:", ";"], (0, _polished.toColorString)(intents.danger.color), (0, _polished.toColorString)(intents.danger.borderColor)),
    dark: (0, _styledComponents.css)(["background-color:", ";border-left-color:", ";"], (0, _polished.toColorString)(intents.danger.color), (0, _polished.toColorString)(intents.danger.borderColor))
  }
});

exports.intentStyle = intentStyle;
var _default = intents;
exports.default = _default;